import { render, staticRenderFns } from "./get-vip-dialog.vue?vue&type=template&id=b8634bd6&"
import script from "./get-vip-dialog.vue?vue&type=script&lang=js&"
export * from "./get-vip-dialog.vue?vue&type=script&lang=js&"
import style0 from "./get-vip-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports